


import CircularProgress from '@mui/material/CircularProgress'; // ✅ NEW IMPORT
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

const AddToListModal1 = ({ onClose, influencerData, onAdded }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [plans, setPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [listNameInput, setListNameInput] = useState('');
  const [listSuggestions, setListSuggestions] = useState([]);
  const [showPlanSuggestions, setShowPlanSuggestions] = useState(true);
  const [showListSuggestions, setShowListSuggestions] = useState(true);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false); // ✅ NEW
  const [error, setError] = useState('');

  const userId = localStorage.getItem('managerID');

  useEffect(() => {
    const fetchManagerPlans = async () => {
      if (!userId) {
        setError('Manager ID not found');
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(`https://server-side-influencer.onrender.com/manager/plans/${userId}`);
        if (!response.ok) throw new Error('Failed to fetch plans');

        const data = await response.json();
        const managerPlans = data?.data?.managerPlans || [];

        setPlans(managerPlans);
        setFilteredPlans(managerPlans);
      } catch (err) {
        console.error('Error fetching manager plans:', err);
        setError('Could not fetch plans.');
      } finally {
        setLoading(false);
      }
    };

    fetchManagerPlans();
  }, [userId]);

  useEffect(() => {
    const filtered = plans.filter(plan =>
      plan.planName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPlans(filtered);
  }, [searchTerm, plans]);

  useEffect(() => {
    if (selectedPlan) {
      const listNames = Array.from(new Set(
        (selectedPlan.influencerDetails || []).map(inf => inf.listName)
      ));
      setListSuggestions(listNames);
    } else {
      setListSuggestions([]);
    }
  }, [selectedPlan]);

  const handleAdd = async () => {
    if (!selectedPlan || !listNameInput || !userId) return;

    const selectedInfluencer = (selectedPlan?.influencerDetails || []).find(
      (inf) => inf.cid === influencerData.cid
    );

    const payload = {
      brandName: selectedInfluencer?.brandname || 'unknown',
      planName: selectedPlan.planName,
      listName: listNameInput,
      cid: influencerData.cid,
      socialType: influencerData.socialType || 'INST',
      groupID: influencerData.groupID || influencerData.cid,
      name: influencerData.name,
      image: influencerData.image,
      url: influencerData.url,
      screenName: influencerData.screenName,
      usersCount: influencerData.usersCount,
      tags: influencerData.tags,
      avgER: influencerData.avgER,
      avgLikes: influencerData.avgLikes || 0,
      avgComments: influencerData.avgComments || 0,
      avgInteractions: influencerData.avgInteractions || 0,
      avgViews: influencerData.avgViews || 0,
      contactEmail: influencerData.contactEmail || '',
      userID: userId
    };

    try {
      setAddLoading(true); // ✅ Start spinner
      const response = await fetch('https://server-side-influencer.onrender.com/manager/createplan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Failed to add influencer');

      Swal.fire({
        title: 'Success!',
        text: 'Influencer added successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
        timer: 3000,
        position: 'center'
      });

      onAdded();
      onClose();
    } catch (error) {
      console.error('Error adding influencer:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to add influencer to the plan.',
        icon: 'error',
        confirmButtonText: 'Try Again',
        timer: 3000,
        position: 'center'
      });
    } finally {
      setAddLoading(false); // ✅ Stop spinners
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl relative">
      <button 
  onClick={onClose} 
  className="absolute top-2 right-2 text-gray-500 hover:text-black text-5xl"
>
  ×
</button>
        <h2 className="text-2xl font-bold mb-4">Add to plan and list</h2>

        {loading ? (
          <p className="text-gray-500">Loading plans...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <>
            {!selectedPlan ? (
              <>
                <input
                  type="text"
                  placeholder="Search or select a plan name..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowPlanSuggestions(true);
                  }}
                  className="w-full p-2 border rounded mb-2"
                />
                {showPlanSuggestions && filteredPlans.length > 0 && (
                  <ul className="max-h-48 overflow-y-auto border rounded p-2 bg-white shadow z-10">
                    {filteredPlans.map((plan, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setSelectedPlan(plan);
                          setSearchTerm(plan.planName);
                          setShowPlanSuggestions(false);
                          setListNameInput('');
                          setShowListSuggestions(true);
                        }}
                        className="cursor-pointer p-2 hover:bg-gray-100 rounded"
                      >
                        {plan.planName}
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ) : (
              <div className="mb-4 flex items-center justify-between bg-gray-100 px-3 py-2 rounded">
                <span className="font-semibold">{selectedPlan.planName}</span>
                <button
                  onClick={() => {
                    setSelectedPlan(null);
                    setListNameInput('');
                    setShowPlanSuggestions(true);
                    setShowListSuggestions(false);
                  }}
                  className="text-red-500 font-bold text-lg ml-2"
                >
                  ×
                </button>
              </div>
            )}

            {selectedPlan && (
              <>
                <input
                  type="text"
                  placeholder="Enter or select a list name..."
                  value={listNameInput}
                  onChange={(e) => {
                    setListNameInput(e.target.value);
                    setShowListSuggestions(true);
                  }}
                  className="w-full p-2 border rounded mb-2"
                />
                {showListSuggestions && listSuggestions.length > 0 && (
                  <ul className="max-h-48 overflow-y-auto border rounded p-2 bg-white shadow z-10">
                    {listSuggestions
                      .filter(name => name.toLowerCase().includes(listNameInput.toLowerCase()))
                      .map((name, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setListNameInput(name);
                            setShowListSuggestions(false);
                          }}
                          className="cursor-pointer p-2 hover:bg-gray-100 rounded"
                        >
                          {name}
                        </li>
                      ))}
                  </ul>
                )}
              </>
            )}
          </>
        )}

        {/* ✅ Button with spinner */}
        <button
          onClick={handleAdd}
          disabled={!selectedPlan || !listNameInput || addLoading}
          className={`mt-4 w-full flex justify-center items-center bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl text-white font-medium rounded-lg text-sm px-5 py-2.5 ${addLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
        >
          {addLoading ? <CircularProgress size={20} color="inherit" /> : 'Add to List'}
        </button>
      </div>
    </div>
  );
};

export default AddToListModal1;
